// Added by Sejune Oh on 2019-09-02
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import axios from 'axios'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { GetQueryReturn } from '@/helper/define'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { GatewayElementProps } from './GatewayStore'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const reqGetGateways = async (path: string = '') => {
    return await axios.get<GetQueryReturn<GatewayElementProps>>(`/v1/mgmt/gateways?${path}`)
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResGetGatewayProps extends GatewayElementProps { }
export const reqGetGateway = async (id: string) => {
    return await axios.get<ResGetGatewayProps>(`/v1/mgmt/gateways/${id}`)
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResCreateGatewayProps extends GatewayElementProps { }
export const reqCreateGateway = async (gatewayElementProps: GatewayElementProps) => {
    return await axios.post<ResCreateGatewayProps>(`/v1/mgmt/gateways`, { ...gatewayElementProps })
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const reqDeleteGateway = async (id: string) => {
    return await axios.delete(`/v1/mgmt/gateways/${id}`)
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResUpdateGatewayProps extends GatewayElementProps { }
export const reqUpdateGateway = async (id: string, gatewayElementProps: GatewayElementProps) => {
    return await axios.put<ResUpdateGatewayProps>(`/v1/mgmt/gateways/${id}`, {
        ...gatewayElementProps,
    })
}
